/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { classNames, randomId } from '@pwskills/rachnaui/utils';
import { useRouter } from 'next/router';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Close, Funnel } from '@pwskills/rachnaui/Icons';
import { Button, Container, Slider, Typography } from '@pwskills/rachnaui';
import { encodeSlugUrl } from '@/utils/helper/helperFunction';
import { ICourses } from '@/interfaces/homePage';
import {
  CategoryPageFilterPayload,
  ICategoryDetails,
  ICourseArrangement,
  ICourseMeta,
  // IDataLayerParam,
  IFilterApiPayload,
  // IFilterArrangement,
  IFiltersArrangement,
  IOfferingFilters,
  IPayloadFilter,
} from '@/interfaces/courseListing';
import CourseListingApi from '@/api/courseListing';
import { Filter, IError } from '@/interfaces/common';
import { dataLayer } from '@/utils/common/dataLayer.utils';
import { sendSkChipsetsInteractedEvent } from '@/utils/GAEventFunction';
import useUserDetails from '@/store/userDetails';
import SortedFilterComponent from './SortedFilterComponent';
import LoadingCardRevampSkeleton from '../../common/LoadingSkeleton/LoadingCardRevampSkeleton';
import Toaster from '../../common/Toaster';
import { OptionLabel, PayloadKey } from '../../../interfaces/courseListing.enum';
import CourseCardRevamp from '../../common/CourseCardRevamp';
import CategoryPageContext from '../../../context/CategoryPageContext';

type Props = {
  categoriesArrangement?: ICourseArrangement[];
  categoryId?: string;
};

const PaidOfferings = ({ categoriesArrangement, categoryId }: Props) => {
  const router = useRouter();
  const [courseMeta, setCourseMeta] = useState<ICourseMeta[]>();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);
  const [coursesDetails, setCoursesDetails] = useState<ICourses[]>();
  const [category, setCategory] = useState<ICategoryDetails[]>([]);
  const [popError, setPopError] = useState<boolean>(false);
  const [isError, setIsError] = useState({
    status: false,
    message: '',
  });
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [offeringsFilterList, setOfferingsFilterList] = useState<IOfferingFilters[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const isFilterEmpty = useRef(false);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isClearSelection, setIsClearSelection] = useState(false);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [isApplyFilterLoading, setIsApplyFilterLoading] = useState(false);
  const [isPreviousCallLengthIsZero, setIsPreviousCallLengthIsZero] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [totalCourses, setTotalCourses] = useState<number>(0);
  const { categorySlug } = router.query;
  const { categoryDetails } = useContext(CategoryPageContext);
  const [filterType, setFilterType] = useState('tag');
  const { userDetails: user, userIsLoggedIn, isUserPaid } = useUserDetails();
  const buttonVisibleClass =
    'opacity-100 cursor-pointer hover:shadow-[0px_4px_20px_rgba(0,0,0,0.10)]';
  const buttonInvisibleClass = 'opacity-50 cursor-default';
  const level = {
    school_student: 'School Student',
    college_student: 'College Student',
    working_professional: 'Working Professional',
  } as Record<string, string>;

  const programType = {
    live: 'Live',
    self_paced: 'Self-Placed Courses',
    campus_edge: 'Campus Edge',
    degree_programs: 'Degree Program',
    bootcamps: 'Bootcamps',
    trending: 'Trending',
    community: 'Community',
  } as Record<string, string>;

  const LanguageType = {
    english: 'English',
    hinglish: 'Hinglish',
    hindi: 'Hindi',
  } as Record<string, string>;

  const payloadLabel: Record<string, keyof IPayloadFilter> = {
    program: 'programType',
    level: 'level',
    domain: 'domains',
    category: 'categories',
    instructor: 'instructors',
    language: 'languages',
    sub_category: 'subcategories',
    subCategory: 'subcategories',
    pricing: 'isFree',
    search: 'text',
    tags: 'hashTag',
    categorySlug: 'filterConfigSlug',
  };

  const generatePayloadFromQuery = (): CategoryPageFilterPayload => {
    const payload: CategoryPageFilterPayload = {
      level: '',
      programType: '',
      text: '',
      instructors: [],
      categories: [],
      languages: [],
      subcategories: [],
      domains: [],
      isFree: '',
      hashTag: [],
      filterConfigSlug: '',
    };
    const queryObject = router.query;

    Object.keys(queryObject).forEach((key) => {
      if (key === 'page') return;
      const payloadKey = payloadLabel[key];
      const queryObjectValue = queryObject[key];
      if (Array.isArray(payload[payloadKey])) {
        if (Array.isArray(queryObjectValue)) {
          (payload[payloadKey] as string[]) = queryObjectValue;
        } else if (queryObjectValue) {
          (payload[payloadKey] as string[]).push(queryObjectValue);
        }
      } else if (payloadKey === 'text') {
        payload[payloadKey] = queryObjectValue as string;
      } else (payload[payloadKey] as string) = queryObjectValue as string;
    });
    return payload;
  };

  const checkIfAnyFilterIsApplied = (data: any) => {
    return Object.keys(data).some((key) => {
      if (key === PayloadKey.UNDEFINED) {
        return false;
      }
      // default keys
      if (key === PayloadKey.FILTER_CONFIG_SLUG) {
        return false;
      }
      // default keys
      if (key === PayloadKey.FILTER_CONFIG_SRC) {
        return false;
      }
      return (
        (typeof data[key] === 'string' && data[key] !== '') ||
        (data[key] !== '' && Array.isArray(data[key]) && data[key].length > 0)
      );
    });
  };

  const getFilteredCourseData = async (pageNumber?: number) => {
    // show loading only on tile selection
    if (!isApplyFilterLoading) setIsLoading(true);
    setIsFilterLoading(true);

    // const filterSearchPayload = generatePayloadFromQuery();
    let filterSearchPayload = generatePayloadFromQuery();

    setIsFilterApplied(checkIfAnyFilterIsApplied(filterSearchPayload));
    // const pageNumber = Number.isNaN(router.query.page) ? -1 : router.query.page;
    try {
      filterSearchPayload = {
        ...filterSearchPayload,
        filterConfigSrc: 'category_page',
        filterConfigCohortId: categoryId || '',
      };

      const response = await CourseListingApi.getFilteredCourse(
        filterSearchPayload as IFilterApiPayload,
        pageNumber ? Number(pageNumber) : 1,
        8
      );

      if (response) {
        const responseData = response?.data;
        if (responseData.courses.length > 0) {
          if (isPreviousCallLengthIsZero) {
            setIsApplyFilter(false);
            setIsPreviousCallLengthIsZero(false);
            setOpen(true);
          } else if (isClearSelection) {
            setOpen(true);
          } else {
            // if (isFilterEmpty) setIsFilterEmpty(false);
            setOpen(false);
            setIsApplyFilter(false);
          }
        }
        if (responseData.courses.length === 0) {
          if (open) {
            setPopError(true);
            setIsError({
              message: 'No Course Found',
              status: false,
            });
            setIsPreviousCallLengthIsZero(true);
            if (isClearSelection) {
              setOpen(true);
            }

            if (isApplyFilter || isFilterEmpty.current) {
              router.push(`/${categorySlug}`).then(() => {
                setOpen(true);
              });
            }
          } else {
            setCoursesDetails(responseData?.courses);
            setActiveFilter(null);
            // to update route if no course found
            // router.push('/courses');
          }
        }
        const courseMetaDetails = responseData?.meta;
        if (responseData.courses.length > 0) {
          setCoursesDetails(responseData?.courses);
          // const totalPages = responseData?.meta[0]?.metadata[0]?.totalPages;
          const offeringFilterDetails = responseData.offeringFilters;
          setOfferingsFilterList(offeringFilterDetails);
          setTotalCourses(responseData.courses.length);
          setTotalPages(courseMetaDetails[0].metadata[0].totalPages);
          // setCourseCount(responseData?.meta[0]?.metadata[0]?.total);
        }
        setCourseMeta(courseMetaDetails);
        setCategory(courseMetaDetails[0]?.category);
      }
      setIsLoading(false);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
      setIsLoading(false);
    } finally {
      setIsFilterLoading(false);
    }
  };

  const mapCategoriesAndArrangement = () => {
    const dataLayerData = {} as Record<string, string>;
    const filterArrangement: IFiltersArrangement = {
      domain: {
        selectType: 'radio',
        filterType: 'Domain',
        filterOption: [],
        filterCount: 0,
      },
      categories: {
        selectType: 'checkbox',
        filterType: 'Category',
        filterOption: [],
        filterCount: 0,
      },
      subCategories: {
        selectType: 'checkbox',
        filterType: 'Sub Category',
        filterOption: [],
        filterCount: 0,
      },
      pricing: {
        selectType: 'radio',
        filterType: 'Pricing',
        filterOption: [],
        filterCount: 0,
      },
      profession: {
        selectType: 'radio',
        filterType: 'Filter by Profession',
        filterOption: [],
        filterCount: 0,
      },
      program: {
        selectType: 'radio',
        filterType: 'Program',
        filterOption: [],
        filterCount: 0,
      },
      language: {
        selectType: 'checkbox',
        filterType: 'Language',
        filterOption: [],
        filterCount: 0,
      },
      instructor: {
        selectType: 'checkbox',
        filterType: 'Instructor',
        filterOption: [],
        filterCount: 0,
      },
      level: {
        selectType: 'radio',
        filterType: 'Level',
        filterOption: [],
        filterCount: 0,
      },
      tags: {
        selectType: 'checkbox',
        filterType: 'Tags',
        filterOption: [],
        filterCount: 0,
      },
    };

    // create domain Arrangement
    categoriesArrangement?.forEach((arrangement: ICourseArrangement) => {
      if (arrangement.domainId) {
        category.forEach((categoryElement: ICategoryDetails) => {
          if (categoryElement.categoryDetails._id === arrangement.domainId) {
            dataLayerData[categoryElement.categoryDetails._id] =
              categoryElement.categoryDetails.title;
            filterArrangement.domain.filterOption.push({
              id: categoryElement.categoryDetails._id,
              count: categoryElement.coursesCount,
              slug: categoryElement.categoryDetails.slug,
              title: categoryElement.categoryDetails.title,
            });
          }
        });
      }
      arrangement.categories.forEach((categoryDetail) => {
        // create Category Arrangement
        if (categoryDetail.categoryId) {
          category.forEach((categoryElement: ICategoryDetails) => {
            if (categoryElement.categoryDetails._id === categoryDetail.categoryId) {
              dataLayerData[categoryElement.categoryDetails._id] =
                categoryElement.categoryDetails.title;
              filterArrangement.categories.filterOption.push({
                id: categoryElement.categoryDetails._id,
                count: categoryElement.coursesCount,
                title: categoryElement.categoryDetails.title,
                slug: categoryElement.categoryDetails.slug,
              });
            }
          });
        }

        // create Subcategory Arrangements
        categoryDetail.subCategories.forEach((subCategoryId) => {
          if (subCategoryId) {
            category.forEach((categoryElement: ICategoryDetails) => {
              if (categoryElement?.categoryDetails?._id === subCategoryId) {
                dataLayerData[categoryElement.categoryDetails._id] =
                  categoryElement.categoryDetails.title;
                filterArrangement?.subCategories.filterOption.push({
                  id: categoryElement?.categoryDetails._id,
                  count: categoryElement?.coursesCount,
                  title: categoryElement?.categoryDetails.title,
                  slug: categoryElement?.categoryDetails.slug,
                });
              }
            });
          }
        });
      });
    });

    courseMeta?.forEach((metadata) => {
      // Profession
      // if (metadata.levels) {
      //   metadata.levels.forEach((levelData) => {
      //     if (profession[levelData._id.level]) {
      //       filterArrangement.profession.filterOption.push({
      //         id: randomId(),
      //         count: levelData.coursesCount,
      //         title: profession[levelData._id.level],
      //         slug: encodeSlugUrl(levelData._id.level),
      //       });
      //     }
      //   });
      // }

      // level
      if (metadata.levels) {
        metadata.levels.forEach((levelData) => {
          if (level[levelData._id.level]) {
            filterArrangement.level.filterOption.push({
              id: randomId(),
              count: levelData.coursesCount,
              title: level[levelData._id.level],
              slug: encodeSlugUrl(levelData._id.level),
            });
          }
        });
      }

      // Tags
      if (metadata.hashTags) {
        metadata.hashTags.forEach((tagData) => {
          filterArrangement.tags.filterOption.push({
            id: randomId(),
            count: tagData?.coursesCount,
            title: tagData.tagName,
            // slug: encodeSlugUrl(languageData?.language),
            slug: tagData.tagSlug,
          });
        });
      }

      // Program type
      metadata.programType.forEach((program) => {
        if (program._id.programType && programType[program._id.programType]) {
          filterArrangement.program.filterOption.push({
            id: randomId(),
            count: program.coursesCount,
            title: programType[program._id.programType],
            slug: encodeSlugUrl(program._id.programType),
          });
        }
      });

      // Pricing Type
      metadata.pricing.forEach((pricing) => {
        filterArrangement.pricing.filterOption.push({
          id: randomId(),
          count: pricing.coursesCount,
          title: pricing._id.isFree === true ? 'Free' : 'Paid',
          slug: encodeSlugUrl(pricing._id.isFree === true ? 'true' : 'false'),
        });
      });

      // Language
      metadata.language.forEach((languageData) => {
        if (languageData.language) {
          filterArrangement.language.filterOption.push({
            id: randomId(),
            count: languageData?.coursesCount,
            title: LanguageType[languageData?.language],
            slug: encodeSlugUrl(languageData?.language),
          });
        }
      });

      // Instructor - Hidden as per SKIL-12739
      // metadata.instructors.forEach((instructorData) => {
      //   if (instructorData.instructorDetails.name) {
      //     dataLayerData[instructorData.instructorDetails._id] =
      //       instructorData.instructorDetails.name;
      //     filterArrangement.instructor.filterOption.push({
      //       id: instructorData.instructorDetails._id,
      //       count: instructorData?.coursesCount,
      //       title: instructorData.instructorDetails.name,
      //       slug: encodeSlugUrl(instructorData.instructorDetails.name),
      //     });
      //   }
      // });
    });

    return { filterArrangement, dataLayerData };
  };

  const checkIfUrlIsPresentInFilters = () => {
    const payloadFromRouter = generatePayloadFromQuery();
    Object.entries(payloadFromRouter).forEach(([key, value]) => {
      if (value.length > 0) {
        // check for category
        if (key === PayloadKey.CATEGORIES) {
          const categoryFilter = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.CATEGORY && item._id === value[0];
          });

          if (categoryFilter) setActiveFilter(categoryFilter[0]?.title);
          else setActiveFilter(null);
        }

        // check for subcategories
        else if (key === PayloadKey.SUBCATEGORIES) {
          const subCategory = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.SUB_CATEGORY && item._id === value[0];
          });
          if (subCategory) setActiveFilter(subCategory[0]?.title);
          else setActiveFilter(null);
        }

        // check for domain
        else if (key === PayloadKey.DOMAINS) {
          const domains = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.DOMAIN && item._id === value[0];
          });
          if (domains) setActiveFilter(domains[0]?.title);
          else setActiveFilter(null);
        }

        // check for tags
        else if (key === PayloadKey.HASHTAG) {
          const tagChoosen = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.TAGS && item._id === value[0];
          });
          if (tagChoosen) setActiveFilter(tagChoosen[0]?.title);
          else setActiveFilter(null);
        }

        // check for pricing
        else if (value !== '' && key === PayloadKey.ISFREE) {
          const pricing = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PRICING && item._id === 'free'
              ? value === 'true'
              : item._id === 'paid'
              ? value === 'false'
              : null;
          });
          if (pricing) setActiveFilter(pricing[0]?.title);
          else setActiveFilter(null);
        }

        // check for programType
        else if (value !== '' && key === PayloadKey.PROGRAMTYPE) {
          const program = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PROGRAM_TYPE && item._id === value;
          });
          if (program) setActiveFilter(program[0]?.title);
          else setActiveFilter(null);
        }

        // check for instructors
        else if (key === PayloadKey.INSTRUCTORS) {
          const instructor = offeringsFilterList.filter((item) => {
            return OptionLabel.INSTRUCTORS && item._id === value[0];
          });
          if (instructor) setActiveFilter(instructor[0]?.title);
          else setActiveFilter(null);
        }

        // check for level
        else if (value !== '' && key === PayloadKey.LEVEL) {
          const levelChoosen = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.PROFESSION && item._id === value;
          });
          if (levelChoosen) setActiveFilter(levelChoosen[0]?.title);
          else setActiveFilter(null);
        }

        // check for language
        else if (key === PayloadKey.LANGUAGES) {
          const language = offeringsFilterList.filter((item) => {
            return item.type === OptionLabel.LANGUAGE && item._id === value[0];
          });
          if (language) setActiveFilter(language[0]?.title);
          else setActiveFilter(null);
        }
      }
    });
    return null;
  };

  const checkFlagPresentInUrl = () => {
    const isFlagPresent = router.query.isFilterChecked === 'true';
    return isFlagPresent;
  };

  const sendDataLayerEvent = (filtersUsed: Filter[]) => {
    const dataLayerObj = {
      event: 'filter_used',
      filter_used: filtersUsed,
      section_name: 'category_paid_course',
      filter_type: filterType,
    };
    dataLayer(dataLayerObj);
  };

  const checkAnyFilterApplied = () => {
    const payload = generatePayloadFromQuery();
    const filtersUsed: Filter[] = [];

    Object.entries(payload).forEach(([key, value]) => {
      if (
        value.length > 0 &&
        key !== PayloadKey.UNDEFINED &&
        key !== PayloadKey.FILTER_CONFIG_SRC &&
        key !== PayloadKey.FILTER_CONFIG_SLUG
      ) {
        filtersUsed.push({ [key]: value });
      }
    });

    if (filtersUsed.length > 0) {
      sendDataLayerEvent(filtersUsed);
    } else {
      setActiveFilter(null);
    }
    if (filtersUsed.length > 0) return true;
    return false;
  };

  useEffect(() => {
    // to rest the scroller to 0
    sessionStorage.setItem('scrollPosition', '0');

    const handleRouteChange = () => {
      // Save the current scroll position when navigating
      sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    // Restore the scroll position when the component mounts
    const scrollPosition: any = sessionStorage.getItem('scrollPosition') || 0;
    window.scrollTo(0, parseInt(scrollPosition, 10));
  }, [router]);

  useEffect(() => {
    if (!checkFlagPresentInUrl() && router.isReady) {
      getFilteredCourseData();
      // sendDataLayerEvent();
      checkAnyFilterApplied();
      // handleScrollToOfferingSection('course-listing-section');
    }
  }, [router, router.isReady]);

  useEffect(() => {
    checkIfUrlIsPresentInFilters();
  }, [offeringsFilterList]);

  useEffect(() => {
    mapCategoriesAndArrangement();
  }, [categoriesArrangement, category]);

  useEffect(() => {
    if (coursesDetails) {
      // FilterDataLayerData();
      router.query.page = '1';
    }
  }, [coursesDetails]);

  const handleFilterClick = (slug: string, optionLabel: string, id: string) => {
    setFilterType('tag');
    let queryParams: string;
    let updatedId = id;
    if (optionLabel === OptionLabel.PROFESSION) {
      queryParams = 'level';
    } else if (optionLabel === OptionLabel.PROGRAM_TYPE) {
      queryParams = 'program';
    } else if (optionLabel === OptionLabel.INSTRUCTORS) {
      queryParams = 'instructor';
    } else if (optionLabel === OptionLabel.PRICING) {
      queryParams = 'pricing';
      if (id === 'free') {
        updatedId = 'true';
      } else {
        updatedId = 'false';
      }
    } else {
      queryParams = optionLabel;
    }

    if (slug !== activeFilter) {
      setIsLoading(true);
      setActiveFilter(slug);

      const params: Record<string, any> = {};
      Object.keys(router.query).forEach((key) => {
        if (!key.startsWith('free')) {
          params[key] = router.query[key];
        }
      });
      const value = router.query[queryParams] === updatedId ? null : updatedId;

      router.push({
        pathname: router.pathname,
        query: { categorySlug, [queryParams]: value, ...params },
      });
    } else {
      setActiveFilter(null);

      // Remove the query parameter from the URL
      const newQuery = { ...router.query };
      delete newQuery[queryParams];

      router.push({
        pathname: router.pathname,
        query: newQuery,
      });
    }
  };

  const handleClearSelection = () => {
    setIsClearSelection(true);
    router.push(`/${categorySlug}`).then(() => {
      setPopError(false);
      if (activeFilter !== null) {
        setActiveFilter(null);
        setOpen(true);
      }
      setOpen(true);
    });
  };

  const handleApplyFilter = () => {
    setFilterType('all_filter');
    setIsApplyFilter(true);
    setIsClearSelection(false);
    // sendDataLayerEvent();
    const { isFilterChecked, ...queryWithoutFlag } = router.query;
    router
      .push({
        pathname: router.pathname,
        query: queryWithoutFlag,
      })
      .then(() => {
        setPopError(false);
        setIsApplyFilterLoading(true);
      });
  };

  const chunkCourses: ICourses[][] = [];
  // to show 6 courses cards at a time
  if (coursesDetails) {
    for (let i = 0; i < coursesDetails.length; i += 8) {
      chunkCourses.push(coursesDetails.slice(i, i + 8));
    }
  }

  // this use effect will load when there are no filters in the meta - all filters
  useEffect(() => {
    if ((coursesDetails?.length === 0 || coursesDetails === undefined) && open) {
      isFilterEmpty.current = true;
      getFilteredCourseData();
    }
  }, [coursesDetails, open]);

  return (
    <div>
      {totalCourses > 0 && (
        <Container className="py-8 large:!py-14 flex flex-col">
          <section id="course-listing-section" data-title="course-listing-section">
            <div>
              <div className="flex items-center">
                <div className="h-[1px] w-[525px] bg-[#B7B7B7]" />
                <Button
                  variant="primary"
                  size="small"
                  className="whitespace-nowrap inline-flex shadow-medium rounded-lg !px-4 !py-2 text-gray-850 mx-4 font-semibold"
                  style={{ backgroundColor: '#F1C571' }}
                >
                  Choose Your Program
                </Button>
                <div className="h-[1px] w-[525px] bg-[#B7B7B7]" />
              </div>

              <div className="flex justify-between items-end gap-[29px]">
                <div className="flex flex-row gap-x-6 overflow-x-auto items-center justify-between mt-6 large:!mt-14 w-full">
                  <div
                    className="flex flex-row gap-x-6 overflow-x-auto"
                    style={{ scrollbarWidth: 'none' }}
                  >
                    {offeringsFilterList.map((item, filterIndex) => {
                      // Hide instructor tabs
                      if (item.type === OptionLabel.INSTRUCTORS) {
                        return null;
                      }
                      if (item.coursesCount > 0) {
                        return (
                          <Button
                            key={item._id} // Ensure each button has a unique key
                            variant="secondary"
                            className={`hover:bg-[#EAECEF] !w-auto !px-4 whitespace-nowrap min-w-fit !text-gray-850 bg-white font-extrabold large:!font-bold rounded-lg !text-[14px] !border !border-[#EFEFEF] !py-[11px] ${
                              activeFilter === item.title
                                ? 'bg-[#FFF0ED] !border-[#E9A091] hover:!bg-[#FFF0ED]'
                                : 'bg-white !border-[#EFEFEF]'
                            }`}
                            onClick={() => {
                              sendSkChipsetsInteractedEvent({
                                userData: user,
                                isLoggedIn: userIsLoggedIn,
                                isUserPaid,
                                page_path: router?.pathname,
                                chipset_type: 'category_paid_offerings_filter',
                                chipset_name: item.title,
                                chipset_id: item._id || item.type,
                                chipset_position: filterIndex + 1,
                                course_batch_category:
                                  categoryDetails?.title || (categorySlug as string) || undefined,
                              });
                              handleFilterClick(item.title, item.type, item._id);
                            }}
                          >
                            <Typography
                              variant="bold"
                              component="body-small"
                              className="min-w-[160px]"
                            >
                              {item.title}
                            </Typography>
                          </Button>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <Button
                    variant="tertiary"
                    className={`whitespace-nowrap min-w-fit !text-gray-850 font-extrabold large:!font-bold rounded-none !text-[14px] !py-[11px] !px-4 hidden large:!block large:!w-[180px] ${
                      isFilterApplied
                        ? '!border !border-orange-500 bg-[#FFF0ED] hover:bg-[#FFF0ED]'
                        : '!text-gray-850 bg-[#f8f8f8] !border-l-[1px] !border-[#B7B7B7] hover:bg-[#EAECEF]'
                    }`}
                    onClick={() => setOpen(true)}
                  >
                    All Filters
                  </Button>
                  <div className="bg-orange-50 rounded-[50%] p-1 h-8 min-w-[32px] flex large:!hidden justify-center items-center cursor-pointer">
                    <Funnel className="text-orange-500 w-4 h-4" onClick={() => setOpen(true)} />
                  </div>
                </div>
              </div>

              <div className="flex flex-row flex-wrap gap-x-[22px] !gap-y-8 medium:!gap-y-8 large:!gap-y-8 !mt-8 medium:!mt-8 large:!mt-9 medium:justify-center !mb-12 medium:!mb-6 large:!mb-8">
                <Slider
                  className={classNames(
                    '!gap-2 medium:!gap-x-[22px] [&>div]:mr-2 [&>*:last-child]:mr-0 !mx-auto [&>div]:large:ml-4'
                  )}
                  prevIconClass={currentPage > 1 ? buttonVisibleClass : buttonInvisibleClass}
                  nextIconClass={
                    currentPage < totalPages ? buttonVisibleClass : buttonInvisibleClass
                  }
                  positionOfSliderInMobile="bottom"
                  onNextClick={() => {
                    if (currentPage < totalPages) {
                      setCurrentPage(currentPage + 1);
                      getFilteredCourseData(currentPage + 1);
                    }
                  }}
                  onPrevClick={() => {
                    if (currentPage > 1) {
                      setCurrentPage(currentPage - 1);
                      getFilteredCourseData(currentPage - 1);
                    }
                  }}
                >
                  {isLoading ? (
                    Array(6)
                      .fill(randomId())
                      .map(() => <LoadingCardRevampSkeleton isButtonSkeleton={false} />)
                  ) : chunkCourses && chunkCourses.length > 0 ? (
                    chunkCourses.map((chunk) => (
                      <div className="relative !w-[100%] !shrink-0 !m-0">
                        <div className="flex flex-wrap justify-center gap-6 ">
                          {chunk.map((course, index) => (
                            <CourseCardRevamp
                              course={course}
                              pageFrom="category_page"
                              key={course._id}
                              section="category_paid_course"
                              categorySlug={categoryDetails?.slug}
                              categoryName={categoryDetails?.title}
                              categoryId={categoryDetails?._id}
                              position="category_page_offering"
                              cardPosition={index + 1}
                              courseType="paid"
                            />
                          ))}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col items-center justify-center w-full">
                      <img
                        src="/images/courseListing/noCourseFound.gif"
                        alt="no-course-found"
                        className="w-[320px] h-[320px]"
                        width={320}
                        height={320}
                      />
                      <Typography
                        variant="semi-bold"
                        component="body-regular"
                        className="text-center text-[16px] text-gray-850"
                      >
                        No Course Found
                      </Typography>
                    </div>
                  )}
                </Slider>
              </div>

              {/* <div>
                {!isLoading && coursesDetails && coursesDetails.length ? (
                  <Pagination
                    pageCount={totalPageCount}
                    currentPage={Number(currentPage)}
                    siblingCount={Number('1')}
                    onPageChange={(number) => {
                      router.query.page = number.toString();
                      router.push(router);
                    }}
                    className="flex flex-row large:w-full medium:gap-14 justify-center medium:!justify-end"
                  />
                ) : null}
              </div> */}
            </div>

            {open && (
              <>
                <div className="h-screen w-screen fixed bg-black opacity-50 top-0 z-[99998] left-0" />
                <div
                  id="slider"
                  className={classNames(
                    'flex flex-col z-[99999] fixed bottom-0 !w-full medium:!w-[75%] medium:!mx-auto h-[85%] large:!w-[40%] large:!right-0 left-0 large:!left-auto medium:!right-0 slide-in bg-white shadow-medium py-6 px-8 medium:h-screen rounded-t-2xl duration-300 transition-all',
                    open ? 'scale-100' : 'scale-0 pointer-events-none'
                  )}
                >
                  <div
                    className={classNames(
                      'flex justify-between gap-x-2 items-center pb-3',
                      'border-b'
                    )}
                  >
                    <div className="flex gap-2 border-stroke-200 sticky top-0 items-center">
                      <Typography
                        component="h3"
                        variant="bold"
                        className={classNames('cursor-default')}
                      >
                        Filters
                      </Typography>
                    </div>
                    <div className="ml-auto p-2 bg-[#EAECEF] rounded-full">
                      <Close
                        onClick={() => {
                          setOpen(false);
                          setIsClearSelection(false);
                        }}
                        className="cursor-pointer"
                      />
                    </div>
                  </div>

                  <div
                    className="flex flex-col !gap-6 medium:!gap-10 h-[100vh] medium:!h-[85vh] large:!h-[75vh] overflow-y-scroll pb-8"
                    style={{ scrollbarWidth: 'none' }}
                    onScroll={(e) => e.stopPropagation()}
                  >
                    <SortedFilterComponent
                      filteredData={mapCategoriesAndArrangement()}
                      activeFilter={activeFilter}
                      isLoading={isFilterLoading}
                    />
                  </div>

                  {popError && (
                    <Toaster
                      open={popError}
                      setOpen={setPopError}
                      text={isError.message}
                      variant={isError.status ? 'success' : 'error'}
                    />
                  )}

                  <div className="flex flex-row absolute left-0 medium:!left-auto !w-full bottom-0 medium:!mb-6 medium:!justify-end medium:!w-fit medium:!self-end medium:!gap-2 bg-white shadow-medium">
                    <Button
                      variant="low-focus"
                      className="bg-white !rounded py-3 px-10 !w-1/2 medium:!w-fit border !border-[#EFEFEF] !text-gray-650 !font-bold whitespace-nowrap"
                      disabled={!checkIfAnyFilterIsApplied(generatePayloadFromQuery())}
                      onClick={handleClearSelection}
                      size="small"
                    >
                      Clear Selection
                    </Button>
                    <Button
                      variant="primary"
                      className="!rounded py-3 px-10 !font-bold !w-1/2 medium:w-fit"
                      disabled={!checkIfAnyFilterIsApplied(generatePayloadFromQuery())}
                      onClick={handleApplyFilter}
                      size="small"
                    >
                      Apply Filters
                    </Button>
                  </div>
                </div>
              </>
            )}
          </section>
        </Container>
      )}
    </div>
  );
};

export default PaidOfferings;
